module.exports = __webpack_public_path__ + "img/Company-logo.55ad13fb.svg";